import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiContentPaste } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const MaterialManagementMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();
    // TODO: Remove the permission check when the MM requests React screen is fully migrated.
    const canViewNewInterface =
      user.can_view_mm_requests_new_interface ?? false;
    const requestedLegacyInterface = new URLSearchParams(
      window.location.search,
    ).get("legacy_interface");
    const legacyInterface = !canViewNewInterface
      ? "true"
      : requestedLegacyInterface === "true" ||
          requestedLegacyInterface === "false"
        ? requestedLegacyInterface
        : localStorage.getItem("legacy_interface") === "false"
          ? "false"
          : "true";

    if (!user.equinor) {
      return null;
    }

    if (
      !(
        user.roles_names.includes("View Materials") ||
        user.roles_names.includes("View Material requests") ||
        user.roles_names.includes("Create Material requests")
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="materialManagement"
          onClick={() => handleClick("materialManagement")}
          title={t("menu.materialManagement.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiContentPaste} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.materialManagement.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon
            icon={
              openSubmenu.materialManagement ? mdiChevronUp : mdiChevronDown
            }
          />
        </ListItemButton>
        <Collapse
          in={openSubmenu.materialManagement}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {user.roles_names.includes("View Materials") && (
              <HybridRouteListItemButtonLink
                caption="materials"
                isReact={false}
                name="materialManagement[materials]"
                sx={{ pl: 4 }}
                title={t("menu.materialManagement.submenu.materials.title")}
                url="/vbuyer/materials_management"
              >
                <ListItemText
                  primary={t("menu.materialManagement.submenu.materials.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("View Material requests") && (
              <HybridRouteListItemButtonLink
                caption="requests"
                isReact={legacyInterface === "false"}
                name="materialManagement[requests]"
                sx={{ pl: 4 }}
                title={t("menu.materialManagement.submenu.requests.title")}
                url={`/vbuyer/mm_requests?legacy_interface=${legacyInterface}`}
              >
                <ListItemText
                  primary={t("menu.materialManagement.submenu.requests.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Create Material requests") && (
              <HybridRouteListItemButtonLink
                caption="create requests"
                name="materialManagement[createRequests]"
                sx={{ pl: 4 }}
                title={t(
                  "menu.materialManagement.submenu.createRequests.title",
                )}
                url="/vbuyer/mm_requests/create_new_requests"
              >
                <ListItemText
                  primary={t(
                    "menu.materialManagement.submenu.createRequests.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {(user.roles_names.includes("Create Material requests") ||
              user.roles_names.includes("View Material requests")) && (
              <HybridRouteListItemButtonLink
                caption="satisfaction survey"
                isReact={false}
                name="materialManagement[satisfactionSurvey]"
                sx={{ pl: 4 }}
                title={t(
                  "menu.materialManagement.submenu.satisfactionSurvey.title",
                )}
                url="/vbuyer/satisfaction_surveys"
              >
                <ListItemText
                  primary={t(
                    "menu.materialManagement.submenu.satisfactionSurvey.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
